module.exports = __webpack_public_path__ + "static/media/pdf-icon.725dc2d5.svg";